/* eslint-disable default-case */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
import BaseDataTransformer from '../base-data-transformer/base-data-transformer';
import tryParseDate from '../../../../util/tryParseDate';

class NamedChartDataToHighchartsDataTransformer extends BaseDataTransformer {
  transformMultiple(data, options) {
    if (data.every(x => x.data.length < 1)) {
      return data.map(x => x.data);
    }

    options.distinctXValues = this.computeDistinctXValues(data);
    return super.transformMultiple(data, options);
  }

  transform(data, options) {
    // Expected format for highcharts series:
    // [{
    //    name: '...',
    //    data: [[date, 7.0], [date, 6.9], ...]
    // }, ...]

    const { distinctXValues } = options;

    const r = [];
    data.columns.forEach((column, i) => {
      // sort by x valuy - either x prop or first array val
      const xSort = ((a, b) => (a.x || a[0]) - (b.x || b[0]));
      const series = {
        name: column,
        meta: data.meta,
        data: data.data.map((ob) => {
          const xAxisTick = this.mapxAxisLabel(ob.name, options);
          const yVal = this.tryParseNumber(ob.values[i]);

          if (options.typeOfFirstColumn === 'date') {
            return [xAxisTick, yVal];
          }
          return { x: distinctXValues.indexOf(ob.name), y: this.forceFloat(yVal), name: xAxisTick };
        }).sort(xSort),
      };
      if (series.data.length > 0) {
        r.push(series);
      }
    });
    return r;
  }

  computeDistinctXValues(data) {
    const xValMap = {};
    data.forEach(chartData => chartData.data.forEach(dataPoint => xValMap[dataPoint.name] = 1));

    return Object.keys(xValMap);
  }

  tryParseNumber(value) {
    const result = this.forceFloat(value);
    return Number.isNaN(result) ? value : result;
  }

  mapxAxisLabel(label, options) {
    if (options && options.typeOfFirstColumn) {
      const columnType = options.typeOfFirstColumn;
      switch (columnType) {
        case 'date': {
          const m = tryParseDate(label);
          label = m.toDate().getTime();
        }
      }
    }
    return label;
  }
}

export default NamedChartDataToHighchartsDataTransformer;
